import React from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import TaxonomyVisualizer from '../components/taxonomy/TaxonomyVisualizer';

const TaxonomyVisualization: React.FC = () => {
  const [searchParams] = useSearchParams();
  const signalId = searchParams.get('signal');

  const handleNodeClick = (nodeId: string, associatedSignals: string[]) => {
    console.log('Node clicked:', nodeId, 'Associated signals:', associatedSignals);
    // TODO: Navigate to signals filtered by this taxonomy item
  };

  return (
    <div className="flex min-h-0 flex-1 flex-col bg-[var(--go-spring)] px-4 py-4 md:px-6 md:py-5 xl:px-8 xl:py-6">
      <div className="mb-6 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
        <div>
          <h1 className="font-jakarta text-2xl font-extrabold tracking-[-0.02em] text-foreground">
            Taxonomy Visualization
          </h1>
          <p className="mt-1 text-[13px] leading-[1.7] text-muted-foreground">
            Explore the conduct intelligence framework by dimension, category, and label.
          </p>
        </div>

        <div className="flex items-center gap-2">
          {signalId ? (
            <Button variant="outline" size="sm">
              <span className="font-mono text-[12px]">Signal {signalId}</span>
            </Button>
          ) : (
            <Button variant="outline" size="sm">
              Framework overview
            </Button>
          )}
        </div>
      </div>

      <nav className="mb-6 flex gap-3">
        <NavLink
          to="/v3/taxonomy"
          className={({ isActive }) =>
            [
              'flex items-center gap-2 rounded-full border px-3 py-2 text-[13px] font-semibold transition-[background-color,color,border-color,box-shadow]',
              isActive
                ? 'border-primary/15 bg-[var(--go-good-vibes-tint)] text-primary shadow-[var(--shadow-card)]'
                : 'border-border bg-background text-muted-foreground hover:border-primary/15 hover:text-foreground',
            ].join(' ')
          }
        >
          Visualization
        </NavLink>
        <NavLink
          to="/v3/settings/taxonomy"
          className={({ isActive }) =>
            [
              'flex items-center gap-2 rounded-full border px-3 py-2 text-[13px] font-semibold transition-[background-color,color,border-color,box-shadow]',
              isActive
                ? 'border-primary/15 bg-[var(--go-good-vibes-tint)] text-primary shadow-[var(--shadow-card)]'
                : 'border-border bg-background text-muted-foreground hover:border-primary/15 hover:text-foreground',
            ].join(' ')
          }
        >
          Settings
        </NavLink>
      </nav>

      <div className="min-h-0 flex-1">
        <TaxonomyVisualizer
          mode={signalId ? 'signal-focused' : 'overview'}
          highlightSignal={signalId || undefined}
          onNodeClick={handleNodeClick}
        />
      </div>
    </div>
  );
};

export default TaxonomyVisualization;
